<script>
  import { applicationLimitationStore } from "@stores/applicationLimitationStore.js";
  import {
    Modal as DangerModal,
    ToastNotification,
  } from "carbon-components-svelte";
  import DataTableBlack from "@components/DataTableBlack.svelte";
  import Modal from "@components/Modal.svelte";
  import { TextInput, SelectItem, Select } from "paxray-components-svelte";

  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";

  import EditIcon from "../../settings/svg/EditIcon.svelte";
  import RemoveIcon from "../../settings/svg/RemoveIcon.svelte";
  import { fly } from "svelte/transition";
  import { projectListStore } from "@stores/damProjectsStore.js";

  export let editable = false;
  export let addedApplications = [];
  export let showTypeSelector = true;

  //let applicationLimitationType = "Blacklist";
  let currentApplicationLimitation = {};
  // Ohne Name und App-Name bzw. URL entstand ein leerer Eintrag; der Fenstertitel bleibt optional
  $: limitationValid =
    Boolean(currentApplicationLimitation.name?.trim()) &&
    Boolean(
      (currentApplicationLimitation.isbrowser
        ? currentApplicationLimitation.url
        : currentApplicationLimitation.appname
      )?.trim(),
    );
  let applicationLimitations = [];
  let applicationLimitationModalOpen = false;
  let deleteConfirmationOpen = false;
  let limitationToDelete = null;
  let page = 1;
  let pageSize = 10;
  let searchValue = "";
  let applicationTypeFilter = 0;
  const applicationTypeFilterOptions = ["All", "Apps", "Websites"];

  const configuredColumnActions = {
    menu: [
      {
        icon: EditIcon,
        label: "Edit",
        onClick: (row) => editApplicationLimitationItem(row.id),
      },
      {
        icon: RemoveIcon,
        label: "Delete",
        danger: true,
        onClick: (row) => {
          limitationToDelete = row;
          deleteConfirmationOpen = true;
        },
      },
    ],
  };

  $: ({ idLimitation } = $projectListStore);

  const {
    subscribe,
    getApplicationLimitations,
    saveApplicationLimitationItem,
    updateDAMLimitation,
    deleteApplicationLimitation,
    closeModal,
    editApplicationLimitationItem,
  } = applicationLimitationStore;

  $: ({
    applicationLimitations,
    applicationLimitationType,
    applicationLimitationModalOpen,
    currentApplicationLimitation,
    saveSuccessful,
    error,
    successMsg,
    errorMsg,
  } = $applicationLimitationStore);

  $: {
    if (idLimitation) {
      getApplicationLimitations(idLimitation);
    }
  }

  function isAlreadyListed(application) {
    return applicationLimitations.some((existing) => {
      if (Boolean(existing.isbrowser) !== Boolean(application.isbrowser))
        return false;
      const existingApp = existing.isbrowser ? existing.url : existing.appname;
      const newApp = application.isbrowser
        ? application.url
        : application.appname;
      return (
        String(existingApp || "").toLowerCase() ===
          String(newApp || "").toLowerCase() &&
        String(existing.windowtitle || "").toLowerCase() ===
          String(application.windowtitle || "").toLowerCase()
      );
    });
  }

  $: {
    if (addedApplications.length > 0) {
      addedApplications
        .filter((application) => !isAlreadyListed(application))
        .forEach((application) => {
          saveApplicationLimitationItem(application, idLimitation);
        });
      addedApplications = [];
    }
  }

  $: filteredApplicationLimitations = applicationLimitations.filter((row) => {
    const matchesType =
      applicationTypeFilter === 0 ||
      (applicationTypeFilter === 1 && !row.isbrowser) ||
      (applicationTypeFilter === 2 && row.isbrowser);
    if (!matchesType) return false;

    const query = searchValue.trim().toLowerCase();
    if (!query) return true;

    const name = row?.name || "";
    const appName = row?.isbrowser ? row?.url : row?.appname;
    const windowTitle = row?.windowtitle || "";

    return [name, appName, windowTitle].some((value) =>
      String(value || "")
        .toLowerCase()
        .includes(query),
    );
  });

  function appIconUrl(row) {
    const application = row?.isbrowser ? row?.url : row?.appname;
    return application
      ? `/api/damprojects/app-icon?application=${encodeURIComponent(application)}`
      : "";
  }

  $: tableHeaders = [
    { key: "name", value: "App/Website" },
    { key: "appname", value: "Technical Name/URL" },
    { key: "windowtitle", value: "Window Title (optional)" },
    ...(editable ? [{ key: "menu", value: "Actions" }] : []),
  ];

  async function confirmDeleteApplicationLimitation() {
    if (!limitationToDelete?.id) return;
    await deleteApplicationLimitation(limitationToDelete.id);
    deleteConfirmationOpen = false;
    limitationToDelete = null;
  }
</script>

{#if showTypeSelector}
  <div>
    {#if editable}
      <Select
        labelText="Limit Application Recording"
        selected={applicationLimitationType}
        on:change={(event) => {
          updateDAMLimitation(idLimitation, event.target.value);
        }}
      >
        <SelectItem value="Whitelist" text="Whitelist" />
        <SelectItem value="Blacklist" text="Blacklist" />
      </Select>
    {:else}
      <span class="limitation-type-title">{applicationLimitationType}</span>
    {/if}
  </div>
{/if}
<DataTableBlack
  headers={tableHeaders}
  rows={filteredApplicationLimitations}
  totalItems={filteredApplicationLimitations.length}
  bind:page
  bind:pageSize
  pageSizes={[10, 25, 50]}
  {searchValue}
  slicePage
  sortable
  showNewButton={editable}
  newButtonText="Add App or Website"
  newButtonIconLeft={false}
  columnActions={editable ? configuredColumnActions : {}}
  on:search={(e) => {
    searchValue = e.detail.value;
    page = 1;
  }}
  on:clearSearch={() => {
    searchValue = "";
    page = 1;
  }}
  on:addNew={() => {
    editApplicationLimitationItem(0);
  }}
>
  <div slot="left-toolbar" class="toolbar_content_switcher">
    <ContentSwitcher
      options={applicationTypeFilterOptions}
      bind:selected={applicationTypeFilter}
    />
  </div>
  <svelte:fragment slot="cell" let:row let:cell>
    {#if cell.key === "name"}
      <div class="app-website-cell">
        {#if appIconUrl(row)}
          <img
            class="application-icon"
            src={appIconUrl(row)}
            alt=""
            aria-hidden="true"
          />
        {/if}
        <span>{cell.value || ""}</span>
      </div>
    {:else if cell.key === "appname"}
      {row.isbrowser ? row.url : row.appname}
    {:else if cell.key !== "menu"}
      {cell.value || ""}
    {/if}
  </svelte:fragment>
</DataTableBlack>

{#if saveSuccessful}
  <div
    in:fly={{ x: 100 }}
    out:fly={{ y: 100 }}
    style="position:fixed; top:50px; right:20px; z-index:9999;"
  >
    <ToastNotification
      fullWidth
      hideAfter={3000}
      timeout={3000}
      kind="success"
      title="Success"
      subtitle={successMsg}
      caption={new Date().toLocaleString()}
      on:close={(e) => {
        e.preventDefault();
      }}
    />
  </div>
{/if}
{#if error}
  <div
    in:fly={{ x: 100 }}
    out:fly={{ y: 100 }}
    style="position:fixed; top:50px; right:20px; z-index:9999;"
  >
    <ToastNotification
      fullWidth
      kind="error"
      title="Error"
      subtitle={errorMsg}
      caption={new Date().toLocaleString()}
      on:close={(e) => {
        e.preventDefault();
      }}
    />
  </div>
{/if}

<Modal
  open={applicationLimitationModalOpen}
  preventCloseOnClickOutside
  modalHeading={`Add App or Website`}
  primaryButtonText="Save"
  primaryButtonValidations={!limitationValid}
  secondaryButtonText="Cancel"
  autowidth
  primaryButtonAction={() => {
    saveApplicationLimitationItem(currentApplicationLimitation, idLimitation);
  }}
  secondaryButtonAction={() => {
    closeModal();
  }}
  actions
  on:close={() => {
    closeModal();
  }}
  on:submit={() => {
    console.log("on submit modal", {
      currentApplicationLimitation,
      idLimitation,
    });
    saveApplicationLimitationItem(currentApplicationLimitation, idLimitation);
  }}
>
  <div class="application-limitation-modal">
    <ContentSwitcher
      bind:selected={currentApplicationLimitation.isbrowser}
      options={["Desktop Application", "Web Application"]}
    ></ContentSwitcher>
    <TextInput
      labelText="Name"
      placeholder="Enter name for rule"
      bind:value={currentApplicationLimitation.name}
    />
    {#if currentApplicationLimitation.isbrowser}
      <TextInput
        labelText="URL"
        placeholder="Regex to Match the Webapp URL (before replacement rules are applied)"
        bind:value={currentApplicationLimitation.url}
      />
    {:else}
      <TextInput
        labelText="Application Name"
        placeholder="Enter application name (without .exe)"
        bind:value={currentApplicationLimitation.appname}
      />
    {/if}
    <TextInput
      labelText="Window Title"
      placeholder="Regex to Match the Window title (before replacement rules are applied)"
      bind:value={currentApplicationLimitation.windowtitle}
    />
  </div>
</Modal>

<DangerModal
  danger
  bind:open={deleteConfirmationOpen}
  preventCloseOnClickOutside
  modalHeading="Remove from whitelist?"
  primaryButtonText="Remove from whitelist"
  secondaryButtonText="Cancel"
  on:click:button--primary={confirmDeleteApplicationLimitation}
  on:click:button--secondary={() => {
    deleteConfirmationOpen = false;
    limitationToDelete = null;
  }}
  on:close={() => {
    deleteConfirmationOpen = false;
    limitationToDelete = null;
  }}
>
  <p>
    Do you really want to remove the following App/Website from the whitelist?
  </p>
  <p><strong>{limitationToDelete?.name || "-"}</strong></p>
</DangerModal>

<style>
  .limitation-type-title {
    font-size: large;
    font-weight: bold;
    color: #333;
  }

  .app-website-cell {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  .application-icon {
    width: 1.25rem;
    height: 1.25rem;
    object-fit: contain;
    flex: 0 0 auto;
  }

  .application-limitation-modal {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
</style>
